module.exports = __webpack_public_path__ + "img/icon-user_blue.64f7e96f.svg";